import { createSlice } from "@reduxjs/toolkit";
import apiHistorySystem from "api/history-system";
import { SLICE_NAME } from "constants/common";
import moment from "moment";
import { setShowBackdrop } from "store/commonSlice";
import store from "store/store";

export const fetchData = async (data) => {
    try {
        store.dispatch(setShowBackdrop(true))
        const res = await apiHistorySystem.getMyHistoryLogin(data)
        if (res.status === 200) {
            store.dispatch(setTableData({
                data: res.data,
                total: res.total
            }))
        }
        else console.log("info: ", res);
    } catch (err) {
        console.log("err: ", err)
    } finally {
        store.dispatch(setShowBackdrop(false))
    }
}

const initialState = {
    tableData: {
        data: [],
        total: 0
    },
    timesearch: {
        startDate: moment().clone().subtract(30, 'days').startOf('day').valueOf(),
        endDate: moment().clone().endOf('day').valueOf(),
    }
}

export const historyPageSlice = createSlice({
    name: SLICE_NAME.HISTORY_PAGE,
    initialState,
    reducers: {
        setTableData: (state, action) => void (state.tableData = action.payload),
        setTimeSearch: {
            reducer: (state, action) => void (state.timesearch = action.payload),
            prepare: (value) => ({ payload: {
                startDate: moment(value.startDate).valueOf(),
                endDate: moment(value.endDate).valueOf(),
            } }),
        }
    }
})

export const { setTableData, setTimeSearch } = historyPageSlice.actions
export default historyPageSlice.reducer
